import { Platform } from '@angular/cdk/platform';
import { Injectable, OnDestroy } from '@angular/core';
import { Subject, Subscription, timer } from 'rxjs';

@Injectable()
export class LandingHeroWordsService implements OnDestroy {
  private timerSubscription: Subscription;
  public word$: Subject<string> = new Subject();

  constructor(private platform: Platform) {}

  ngOnDestroy(): void {
    if (this.timerSubscription) this.timerSubscription.unsubscribe();
  }

  public initiateRollSequence(words: string[]): void {
    if (!this.platform.isBrowser) return undefined;
    let index = 0;
    this.timerSubscription = timer(0, 4000).subscribe(() => {
      this.word$.next(words[index]);
      index = (index + 1) % words.length;
    });
  }
}
